export default {
  brandClasses: 'hide-chat-button'
}
